<div #container class="locationTreeTarget" id="treeTarget">
  <div class="header-right-tools">
    <button type="button" class="btn btn-header-tools" (click)="selectAllLocations()" placement="left"
            [ngbTooltip]="allSelectedValue
                ? ('SELECT ALL' |translate ) : ('DESELECT ALL'|translate)">{{allSelectedValue
      ? ('SELECT ALL' |translate) : ('DESELECT ALL'|translate)}}
    </button>
    <button type="button" class="btn btn-datepicker" style="background: green"
            (click)="loadChart()" placement="left"
            [ngbTooltip]="'TOOL_RELOAD_DATA' | translate">
      <fa-icon [icon]="faCheck"></fa-icon>
    </button>
    <button type="button" class="btn btn-datepicker" style="background: deepskyblue"
            (click)="loadChart(true)" placement="left"
            [ngbTooltip]="'CHART_RESET_ZOOM' | translate">
      <fa-icon [icon]="faSync"></fa-icon>
    </button>
    <button *ngIf="showDragDropButton" type="button" class="btn btn-datepicker" style="background: deepskyblue"
            (click)="openDragDropLocationsList()"
            [ngbTooltip]="'ORDER_LOCATIONS_USING_DRAG_DROP' | translate">
      <fa-icon style="margin-bottom: 3px" [icon]="faSort"></fa-icon>
    </button>
  </div>
  <div class="tree-container">
    <mat-accordion multi="true">
      <mat-expansion-panel *ngFor="let l of locations;let i = index" class="location-tree"
                           [expanded]="l.expanded"
                           (opened)="panelToggled(l, true)"
                           (closed)="panelToggled(l, false)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="selectLocation(l, $event)"
                          [checked]="l.selected"
                          [indeterminate]="setTreeLocationIndeterminate(l)">
              <img *ngIf="l.type" [src]="'../../../assets/images/chart/' + getImg(l.type) +'.png'"
                   class="list-picto-device"/> {{l.name}} <span
              *ngIf="l.length">&nbsp;({{l.length}}m)</span></mat-checkbox>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngIf="l.unit?.length>0">
        <span class="unit-checkbox" *ngFor="let ul of l.unit;let u = index">
        <mat-checkbox [checked]="ul.selected"
                      (change)="selectUnit(ul, l, $event)"> {{ul.value}}
        </mat-checkbox><b class="pastilleTree" [ngStyle]="{'backgroundColor': ul.color }"></b>
            </span>
        </div>

        <mat-accordion multi="true">
          <mat-expansion-panel *ngFor="let lc of l.child;let c = index"
                               [expanded]="lc.expanded">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-checkbox (click)="$event.stopPropagation()"
                              (change)="selectLocation(lc, $event, l)"
                              [checked]="lc.selected"
                              [indeterminate]="setTreeLocationIndeterminate(lc)">
                  <img [src]="'../../../assets/images/chart/' + getImg(lc.type) +'.png'"
                       class="list-picto-device"/>{{lc.name}}
                  <span *ngIf="lc.length">&nbsp;({{lc.length}}m)</span>
                </mat-checkbox>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngIf="lc.unit?.length>0">
            <span class="unit-checkbox" *ngFor="let u of lc.unit;let lu = index">
            <mat-checkbox
              [checked]="u.selected"
              (change)="selectUnit(u, lc, $event)">
                {{u.value}}
            </mat-checkbox>
            <b class="pastilleTree" [ngStyle]="{'backgroundColor': u.color }"></b>
                </span>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <br clear="left"/>
</div>
